import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import Hearts from '../../../common/Hearts'
import { Visitor } from '../Intro'
import './index.scss'
import { ReactComponent as Heart } from '../../../../assets/Vector.svg'
import { changeCareerCoopState } from '../../../../stores/GlobalState'

const EndBlock = observer(() => {
  const end = ContentState.career.end
  if (!end) return <></>
  return (
    <section className="end-block">
      <div className="end-block__title">
        {Visitor.name.length ? Visitor.name : end.subtitle}
        {end.title}
      </div>
      <div
        className="end-block__text"
        dangerouslySetInnerHTML={{ __html: end.text }}
      ></div>
      <div className="end-block__heart">
        <Heart className="screen__heart" />
        <Hearts />
      </div>
      <div className="button white" onClick={changeCareerCoopState}>
        {ContentState.career.vacancies.buttonText}
      </div>
    </section>
  )
})

export default EndBlock
